"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _pacomo = require("utils/pacomo");

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _components2 = require("components");

var _selectors = require("selectors");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    StatusInput: {
        displayName: "StatusInput"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/StatusInput.js",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var StatusInput = _wrapComponent("StatusInput")((0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(StatusInput, _React$Component);

    function StatusInput(props) {
        (0, _classCallCheck3.default)(this, StatusInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (StatusInput.__proto__ || (0, _getPrototypeOf2.default)(StatusInput)).call(this, props));

        _this.state = {
            hasUpdated: "0"
        };
        return _this;
    }

    (0, _createClass3.default)(StatusInput, [{
        key: "onClick",
        value: function onClick(customerId) {
            var _props = this.props,
                input = _props.input,
                requirement = _props.requirement;
            // Extract roommates for approval to avoid adding "phantom" roommates.

            var resourceFields = _lodash2.default.get(requirement, "resource_fields", []);
            var roomMates = resourceFields.find(function (f) {
                return f.field === "room_mates";
            });

            this.setState({
                hasUpdated: "1"
            });
            if (customerId === "delete" && requirement.customer) {
                return input.onChange({
                    toDelete: requirement.customer
                });
            }

            // Return an empty list if no roommates are present in the requirement set.
            var approvedByCustomers = roomMates && roomMates.value ? roomMates.value.map(function (mate) {
                return { id: mate.id };
            }) : [];

            return input.onChange(approvedByCustomers);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                input = _props2.input,
                requirement = _props2.requirement,
                helpText = _props2.helpText,
                _props2$meta = _props2.meta,
                touched = _props2$meta.touched,
                error = _props2$meta.error;


            var inputs = _react3.default.createElement(
                "div",
                { className: "inputs" },
                _react3.default.createElement(
                    "div",
                    {
                        className: "input-container " + (input.value && !input.value["toDelete"] && input.value != "Unknown" ? "input-selected" : ""),
                        onClick: function onClick() {
                            _this2.onClick(requirement.customer);
                        }
                    },
                    _react3.default.createElement(
                        "div",
                        { className: "label" },
                        _react3.default.createElement(
                            "h3",
                            null,
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: "RoomingInformation.statusInput.approveHeading",
                                defaultMessage: "Approve"
                            })
                        ),
                        _react3.default.createElement(
                            "p",
                            null,
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: "RoomingInformation.statusInput.approveText",
                                defaultMessage: "You agree to room with this passenger."
                            })
                        )
                    )
                ),
                _react3.default.createElement(
                    "div",
                    {
                        className: "input-container " + ((!input.value || input.value["toDelete"] || input.value == "Unknown") && this.state.hasUpdated == "1" ? "input-selected" : ""),
                        onClick: function onClick() {
                            _this2.onClick("delete");
                        }
                    },
                    _react3.default.createElement(
                        "div",
                        { className: "label" },
                        _react3.default.createElement(
                            "h3",
                            null,
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: "RoomingInformation.statusInput.deleteHeading",
                                defaultMessage: "Delete Request"
                            })
                        ),
                        _react3.default.createElement(
                            "p",
                            null,
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: "RoomingInformation.statusInput.disapproveText",
                                defaultMessage: "This will reset this rooming request."
                            })
                        )
                    )
                )
            );

            return _react3.default.createElement(
                "div",
                null,
                _react3.default.createElement(_components2.FieldHelpErrorText, {
                    touched: touched,
                    error: error,
                    helpText: helpText
                }),
                inputs
            );
        }
    }]);
    return StatusInput;
}(_react3.default.Component)) || _class);

var mapStateToProps = function mapStateToProps(state) {
    return {
        customersById: (0, _selectors.getAllCustomers)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StatusInput);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/StatusInput.js
// module id = 636
// module chunks = 0